import { render, staticRenderFns } from "./CombinationData.vue?vue&type=template&id=ed81505c&"
import script from "./CombinationData.vue?vue&type=script&lang=js&"
export * from "./CombinationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports